export default function PersonalInfoForm({ client }) {
  return (
      <div className="space-y-4">
        <div>
          <label onClick={()=>console.log(client)} className="block text-sm font-medium text-gray-700 mb-1">
            Full Name
          </label>
          <input
            type="text"
            value={client.firstName + " "+ client.lastName }
            readOnly
            className="w-full p-2 border rounded-lg "
          />
        </div>
  
        <div className="flex flex-col md:grid md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Gender
            </label>
            <input
              type="text"
              value={client.gender}
              readOnly
              className="w-full p-2 border rounded-lg "
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Age
            </label>
            <input
              type="text"
              value={client.age}
              readOnly
              className="w-full p-2 border rounded-lg "
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Marital Status
            </label>
            <input
              type="text"
              value={client.maritalStatus}
              readOnly
              className="w-full p-2 border rounded-lg "
            />
          </div>
        </div>
  
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Address
          </label>
          <input
            type="text"
            value={client.address}
            readOnly
            className="w-full p-2 border rounded-lg "
          />
        </div>
  
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              City
            </label>
            <input
              type="text"
              value={client.city}
              readOnly
              className="w-full p-2 border rounded-lg "
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Country
            </label>
            <input
              type="text"
              value={client.country}
              readOnly
              className="w-full p-2 border rounded-lg "
            />
          </div>
        </div>
  
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Zip Code
            </label>
            <input
              type="text"
              value={client.zipcode}
              readOnly
              className="w-full p-2 border rounded-lg "
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mobile No.
            </label>
              <input
                type="text"
              value={client.mobileNumber}
                readOnly
                className="w-full p-2 border rounded-lg "
              />
          </div>
        </div>
  
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email Address
          </label>
          <input
            type="email"
            value={client.email}
            readOnly
            className="w-full p-2 border rounded-lg "
          />
        </div>
  
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Employment Type
          </label>
          <input
            type="text"
            value={client.employmentType}
            readOnly
            className="w-full p-2 border rounded-lg "
          />
        </div>
  
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Visa Category
          </label>
          <input
            type="text"
            value={client.visaCategory}
            readOnly
            className="w-full p-2 border rounded-lg "
          />
        </div>
  
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Inquiry Type
          </label>
          <input
            type="text"
            value={client.inquiryType}
            readOnly
            className="w-full p-2 border rounded-lg "
          />
        </div>
      </div>
    )
  }
  
  